import { ref } from 'vue';

function useLoading(loading: boolean): { isLoading } {
  const isLoading = ref(loading);

  return { isLoading };
}

export default useLoading;
